import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  InteractionManager,
  Platform,
  RefreshControl,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';
import Utils from '../utils/Utils';
import LoadingIndicator from '../common/LoadingIndicator';
import APIClient from '../utils/APIClient';
import UserUtils from '../utils/UserUtils';
import { RightButton } from '../navigation/NavigationButtons';
import Icon from '../common/Icon';
import AlertUtils from '../utils/AlertUtils';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class PartnerScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    const {openOrderList, openAgencyList} = params ? params : {};
    return {
      headerBackTitle: null,
      headerTitle: 'Đối tác',
      headerRight: (
        <View
          style={{
            flexDirection: 'row',
          }}>
          <RightButton
            component={<Icon
              type='MaterialIcons'
              name='store'
              size={26}
              color='#ffffff'/>
            }
            onClick={openOrderList}/>
          <RightButton
            component={<Icon
              type='FontAwesome'
              name='users'
              size={20}
              color='#ffffff'/>
            }
            onClick={openAgencyList}/>
        </View>
      ),
    };
  };

  constructor (props) {
    super(props);

    this.state = {
      status: 'none',
    };

    if (Platform.OS === 'web') {
      this._id = this.props.match.params.id;
    } else {
      this._id = this.props.navigation.state.params.id;
    }
  }

  componentDidMount () {
    if (Platform.OS !== 'web') {
      const {navigation} = this.props;
      navigation.setParams({
        openAgencyList: this._openAgencyList,
        openOrderList: this._openOrderList,
      });
    }

    if (Platform.OS === 'web') {
      this._refreshData(false);
    } else {
      InteractionManager.runAfterInteractions(() => {
        this._refreshData(false);
      });
    }
  }

  componentWillUnmount () {
  }

  _onRefresh = () => this._refreshData(true);

  _refreshData = (refreshing) => {
    const {status} = this.state;
    if (this.state.refreshing || status === 'loading') {
      return;
    }

    this.setState({
      refreshing: refreshing,
      status: refreshing ? 'none' : 'loading',
    });

    this._loadData();
    this._loadLogs();
  };

  _loadData = async () => {
    const path = `/admin/user/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      this._updateData(response.response);
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Có lỗi xảy ra, vui lòng thử lại sau');
      AlertUtils.alert({message});
      this.setState({
        refreshing: false,
        status: 'failed',
      });
    }
  }

  _updateData (data) {
    const {name, email, phone, address, revenue, commission, multilevelRevenue, multilevelCommission, active} = data;
    const items = [];
    items.push({
      title: 'Thông tin',
      section: true,
    });
    items.push({
      title: 'Tên',
      value: _.isEmpty(name) ? 'N/A' : name,
    });
    items.push({
      title: 'Email',
      value: _.isEmpty(email) ? 'N/A' : email,
    });
    items.push({
      title: 'Số điện thoại',
      value: _.isEmpty(phone) ? 'N/A' : phone,
    });
    items.push({
      title: 'Địa chỉ',
      value: _.isEmpty(address) ? 'N/A' : address,
    });
    items.push({
      title: 'Doanh thu (tháng này)',
      value: Utils.priceToString(revenue),
    });
    items.push({
      title: 'Hoa hồng (tháng này)',
      value: commission + '%',
    });
    items.push({
      title: 'Doanh thu đại lý con (tháng này)',
      value: Utils.priceToString(multilevelRevenue),
    });
    items.push({
      title: 'Hoa hồng từ đại lý con',
      value: multilevelCommission + '%',
    });
    items.push({
      title: 'Trạng thái hoạt động',
      value: active ? 'Đang hoạt động' : 'Ngừng hoạt động',
    });

    this.setState({
      status: 'done',
      data: data,
      items: items,
    });

    const {user} = this.props;
    // console.log('user: ' + JSON.stringify(user));
    const canEdit = UserUtils.isAdmin(user);
    // console.log('can edit: ' + canEdit);
    const editActions = this._generateEditActions(data);

    this.setState({
      refreshing: false,
      status: 'done',
      data: data,
      items: items,
      canEdit: canEdit,
      editActions: editActions,
    });
  }

  _loadLogs = async () => {
    const {user} = this.props;
    const isAdmin = UserUtils.isAdmin(user);
    if (!isAdmin) {
      return;
    }

    if (_.isNil(this._id)) {
      return;
    }

    this.setState({
      logs: [
        {
          title: 'Nhật kí',
          section: true,
        },
      ],
    });

    const path = `/logs/user/${this._id}`;
    const {response, error} = await APIClient.GET(path);
    if (response) {
      console.log('user logs response: ', response);
    }
    if (error) {
      console.warn('user logs error: ', error);
    }
    if (_.isNil(response) || _.isEmpty(response.response)) {
      return;
    }

    let {logs} = this.state;
    for (let data of response.response) {
      const items = this._parseLog(data);
      logs = logs.concat(items);
    }
    this.setState({
      logs,
    });
  };

  _parseLog = (data) => {
    const items = [];
    const {username, content, updatedAt} = data;
    items.push({
      title: 'Người tạo',
      value: username,
    });
    items.push({
      title: 'Nội dung',
      value: content,
    });
    items.push({
      title: 'Thời gian',
      value: Utils.dateToString(updatedAt),
    });
    return items;
  };

  _edit = () => {
    if (Platform.OS === 'web') {
      return;
    }

    const {user} = this.props;
    if (!UserUtils.isAdmin(user) && !UserUtils.isPartner(user)) {
      return;
    }

    const {editing} = this.state;
    if (editing) {
      return;
    }

    const actions = this._generateEditActions(this.state.data);
    actions.push({
      text: 'Bỏ qua',
      style: 'cancel',
    });

    Alert.alert(
      global.__APP_NAME__,
      'Cập nhật',
      actions,
    );
  };

  _generateEditActions = (data) => {
    const {active} = data;
    const actions = [];

    if (Platform.OS === 'web') {
      actions.push({
        id: 'agency-list',
        text: 'Đại lý của đối tác',
        onPress: this._openAgencyList,
      });

      actions.push({
        id: 'order-list',
        text: 'Đơn hàng của đối tác',
        onPress: this._openOrderList,
      });
    }

    actions.push({
      id: 'update',
      text: 'Cập nhật thông tin',
      onPress: this._updateSale,
    });

    actions.push({
      id: 'update-price',
      text: 'Cập nhật giá bán',
      onPress: this._updatePrice,
    });

    actions.push({
      id: active ? 'deactive' : 'active',
      text: active ? 'Huỷ đối tác' : 'Kích hoạt đối tác',
      onPress: this._toggleActivation,
    });
    return actions;
  };

  _openAgencyList = () => {
    const {data} = this.state;
    if (Platform.OS === 'web') {
      const path = '/agencies/' + data.id;
      this.props.history.push(path);
    } else {
      this.props.navigation.push('AgencyList', {
        id: data.id,
      });
    }
  };

  _openOrderList = () => {
    const {data} = this.state;
    if (Platform.OS === 'web') {
      const path = '/orders/seller/' + data.id;
      this.props.history.push(path);
    } else {
      this.props.navigation.push('SellerOrderList', {
        id: data.id,
      });
    }
  };

  _updateSale = () => {
    const {data} = this.state;
    if (Platform.OS === 'web') {
      this.props.history.push({
        pathname: `/seller/${data.id}`,
      });
    } else {
      this.props.navigation.navigate('Seller', {
        id: data.id,
      });
    }
  };

  _updatePrice = () => {
    const {data} = this.state;
    if (Platform.OS === 'web') {
      this.props.history.push({
        pathname: `/seller/price/${data.id}`,
      });
    } else {
      this.props.navigation.navigate('SellerPrice', {
        id: data.id,
      });
    }
  };

  _toggleActivation = () => {
    const partner = this.state.data;
    const {active} = partner;
    const data = {
      active: !active,
    };
    this._confirmEdit(
      active
        ? 'Bạn thực sự muốn huỷ đối tác này?'
        : 'Bạn thực sự muốn kích hoạt đối tác này?',
      'active',
      data,
      active ? 'Huỷ đối tác' : 'Kích hoạt đối tác',
      active ? 'Huỷ đối tác thành công' : 'Kích hoạt đối tác thành công',
      active
        ? 'Huỷ đối tác thất bại, vui lòng thử lại sau'
        : 'Kích hoạt đối tác thất bại, vui lòng thử lại sau',
    );
  };

  _confirmEdit = (
    confirmMessage, editAction, data, editActionText, successMessage,
    failureMessage) => {
    const {editing} = this.state;
    if (editing) {
      return;
    }

    if (Platform.OS === 'web') {
      const result = window.confirm(confirmMessage);
      if (result) {
        this._doEdit(editAction, data, successMessage, failureMessage);
      }
    } else {
      Alert.alert(
        global.__APP_NAME__,
        confirmMessage,
        [
          {text: 'Bỏ qua', style: 'cancel'},
          {
            text: editActionText,
            onPress: () => this._doEdit(editAction, data, successMessage,
              failureMessage),
          },
        ],
      );
    }
  };

  _doEdit = async (editAction, data, successMessage, failureMessage) => {
    this.setState({
      editing: true,
      editAction: editAction,
    });

    const partner = this.state.data;
    const {active} = partner;
    const status = active ? 'deactive' : 'active';
    const path = `/seller/${partner.id}/${status}`;
    const {response, error} = await APIClient.POST(path);
    this._handleEditNetworkResponse(response, error, successMessage,
      failureMessage);
  };

  _handleEditNetworkResponse (response, error, successMessage, failureMessage) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    if (response && response.response) {
      const agency = response.response;
      if (!_.isEmpty(agency) && agency.id > 0) {
        let {data} = this.state;
        data = Object.assign(data, agency);
        this._updateData(data);
        this._loadLogs();
      }

      const message = successMessage;
      AlertUtils.alert({message});
    } else {
      const message = Utils.parseErrorMessage(response, error, failureMessage);
      AlertUtils.alert({message});
    }

    this.setState({
      editing: false,
      editAction: '',
    });
  }

  _renderItem = (item, index, dividerHidden) => {
    const {section, title, value} = item;
    return (
      <View
        key={index}
        style={[
          styles.item, {
            paddingTop: section ? 20 : 8,
            paddingBottom: section ? 0 : 8,
          }]}>
        <Text
          style={section ? styles.itemSectionText : styles.itemTitleText}>
          {title}
        </Text>
        {!section && <Text
          style={styles.itemValueText}>
          {value}
        </Text>}
        {!section && !dividerHidden && <View
          style={styles.itemDivider}/>}
      </View>
    );
  };

  _renderEditAction = (action) => {
    const {id, text, onPress} = action;
    const {editAction} = this.state;
    return (
      <TouchableOpacity
        key={id}
        activeOpacity={0.75}
        onPress={onPress}
        style={styles.actionButton}>
        <Image
          source={require('../img/btn.png')}
          style={styles.actionButtonImage}/>
        <Text
          style={styles.actionButtonText}>
          {text}
        </Text>
        {id === editAction && <View
          style={styles.actionActivity}>
          <ActivityIndicator
            animating
            color='#ffffff'
            style={styles.actionActivityIndicator}/>
        </View>}
      </TouchableOpacity>
    );
  };

  render () {
    const {user} = this.props;
    const {refreshing, status, items, logs, canEdit, editing, editActions} = this.state;
    return (
      <View
        style={styles.container}>
        <ScrollView
          automaticallyAdjustContentInsets={false}
          refreshControl={
            <RefreshControl
              refreshing={refreshing}
              onRefresh={this._onRefresh}/>
          }
          style={styles.content}>
          {!_.isEmpty(items) && <View
            style={styles.contentContainer}>
            <View
              style={styles.info}>
              {items.map((item, index) => this._renderItem(item, index, true))}

              {Platform.OS === 'web' && canEdit && !_.isEmpty(editActions)
              && <View
                style={styles.actionList}>
                {editActions.map(this._renderEditAction)}
              </View>}
            </View>
            {!_.isEmpty(logs) && <View
              style={styles.logs}>
              {logs.map((item, index) => this._renderItem(item, index,
                index % 3 !== 0))}
            </View>}
          </View>}
        </ScrollView>

        {Platform.OS !== 'web' && canEdit && <TouchableOpacity
          activeOpacity={0.75}
          onPress={this._edit}
          style={[
            styles.actionButton, {
              marginTop: 20,
              marginBottom: 20,
              alignSelf: 'center',
            }]}>
          <Image
            source={require('../img/btn.png')}
            style={styles.actionButtonImage}/>
          <Text
            style={styles.actionButtonText}>
            CẬP NHẬT
          </Text>
          {editing && <View
            style={styles.actionActivity}>
            <ActivityIndicator
              animating={true}
              color='#ffffff'
              style={styles.actionActivityIndicator}/>
          </View>}
        </TouchableOpacity>}

        {status === 'loading' && <LoadingIndicator/>}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    flexDirection: (Dimensions.get('window').width < 600 ? 'column' : 'row'),
    backgroundColor: '#f6efdb',
  },
  info: {
    flex: 1,
  },
  logs: {
    flex: 1,
    borderLeftWidth: 1,
    borderLeftColor: '#f6efdb',
  },

  item: {
    flexDirection: 'row',
  },
  itemSectionText: {
    marginLeft: 10,
    color: '#000000',
    fontSize: 17,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
  },
  itemTitleText: {
    marginLeft: 20,
    color: '#000000',
    fontSize: 17,
    fontWeight: '100',
    backgroundColor: 'transparent',
    ...Platform.select({
      ios: {
        flex: 1,
      },
      android: {
        flex: 1,
      },
    }),
  },
  itemValueText: {
    flex: 1,
    marginLeft: 10,
    marginRight: 10,
    color: '#6b7adc',
    fontSize: 17,
    fontWeight: '300',
    textAlign: 'right',
    backgroundColor: 'transparent',
  },
  itemDivider: {
    position: 'absolute',
    left: 20, bottom: 0, right: 10,
    height: 1,
    backgroundColor: '#6b7adc',
  },

  actionList: {
    width: contentWidth,
    alignSelf: 'center',
  },
  actionButton: {
    width: contentWidth,
    height: 56,
    marginTop: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  actionButtonImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  actionButtonText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  actionActivity: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
  },
  actionActivityIndicator: {},
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerScreen);



// WEBPACK FOOTER //
// ./src/partner/PartnerScreen.js